
import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class ServiceRegionActions extends Actions{
    static get target(){
        return 'serviceRegions'
    }

    static fetch (data) {
        return this.client.organizations.serviceRegions.fetch(data)
    }
}


// WEBPACK FOOTER //
// ./actions/ServiceRegionActions.js